const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8787/api';

export interface ActiveEvent {
  id: string;
  title: string;
  description?: string;
  startDate: string;
  endDate: string;
  type: string;
  status?: string;
  image?: string;
  promotionType?: string;
  actionUrl?: string;
  actionText?: string;
  eventDetails?: {
    teams?: string[];
    venue?: string;
    kickoffAt?: string;
  };
}

export const eventService = {
  async getActivePromotions(): Promise<ActiveEvent[]> {
    try {
      const res = await fetch(`${API_BASE}/events/promotions/active`);
      if (!res.ok) return [];
      return await res.json();
    } catch {
      return [];
    }
  },

  async getActiveGameEvents(): Promise<ActiveEvent[]> {
    try {
      const res = await fetch(`${API_BASE}/events/active?type=event`);
      if (!res.ok) return [];
      return await res.json();
    } catch {
      return [];
    }
  },
};
